module.exports = __webpack_public_path__ + "static/media/logo.c4d86325.jpg";